import mock from '../mock'
import { paginateArray } from '../utils'

const data = {
  leaseCombined: [
    {
      id: 1,
      client: {
        idODOO: 'odoo #00100',
        name: 'Client A'
      },
      total: 5592.50,
      company: 'Quantum',
      role: 'admin',
      username: 'ernesto',
      country: 'México',
      contact: '(123) 456-7890',
      email: 'ernesto@sqnlatina.com',
      currentPlan: 'demo',
      status: 'active',
      avatar: require('@src/assets/images/avatars/1.png').default
    },
    {
      id: 2,
      client: {
        idODOO: 'odoo #00101',
        name: 'Client B'
      },
      total: 7200.00,
      company: 'Quantum',
      role: 'client',
      username: 'demo',
      country: 'México',
      contact: '(123) 456-7890',
      email: 'demo@sqnlatina.com',
      currentPlan: 'demo',
      status: 'inactive',
      avatar: require('@src/assets/images/avatars/10.png').default
    }
  ]
}

// GET ALL DATA
mock.onGet('/api/lease-combined/list/all-data').reply(200, data.leaseCombined)

// POST: Add new user
mock.onPost('/apps/lease-combined/add-user').reply(config => {
  // Get event from post data
  const user = JSON.parse(config.data)

  const { length } = data.leaseCombined
  let lastIndex = 0
  if (length) {
    lastIndex = data.leaseCombined[length - 1].id
  }
  user.id = lastIndex + 1

  data.leaseCombined.unshift(user)

  return [201, { user }]
})

// GET Updated DATA
mock.onGet('/api/lease-combined/list/data').reply(config => {
  const { q = '', perPage = 10, page = 1, role = null, currentPlan = null, status = null } = config

  /* eslint-disable  */
  const queryLowered = q.toLowerCase()
  const filteredData = data.leaseCombined.filter(
    user =>
      (user.username.toLowerCase().includes(queryLowered) || user.fullName.toLowerCase().includes(queryLowered)) &&
      user.role === (role || user.role) &&
      user.currentPlan === (currentPlan || user.currentPlan) &&
      user.status === (status || user.status)
  )
  /* eslint-enable  */

  return [
    200,
    {
      users: paginateArray(filteredData, perPage, page),
      total: filteredData.length
    }
  ]
})

// GET USER
mock.onGet('/api/lease-combined/user').reply(config => {
  const { id } = config
  const user = data.leaseCombined.find(i => i.id === id)
  return [200, { user }]
})

// DELETE: Deletes User
mock.onDelete('/apps/lease-combined/delete').reply(config => {
  // Get user id from URL
  let userId = config.id

  // Convert Id to number
  userId = Number(userId)

  const userIndex = data.leaseCombined.findIndex(t => t.id === userId)
  data.leaseCombined.splice(userIndex, 1)

  return [200]
})
